import React from 'react';
import {t} from '@lingui/core/macro';

import {ITariffVariant} from 'entities/tariff';

import AdminFormModal, {IAdminEntityModalProps} from '../AdminList/AdminFormModal';
import TariffVariantForm from './TariffVariantForm';

const TariffVariantModal: React.FC<IAdminEntityModalProps<ITariffVariant>> = (props) => (
    <AdminFormModal {...props} addHeader={t`Добавить пакет`} editHeader={t`Изменить пакет`} Form={TariffVariantForm}/>
);

export default TariffVariantModal;
